import { z } from "zod";

export const DeleteInventoryCategoryResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
});

export type DeleteInventoryCategoryResponse = z.infer<typeof DeleteInventoryCategoryResponseSchema>;
